import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EditorPublishButton from 'ContentEditorUI/components/shared/EditorPublishButton';
import { getCannotPublishOnActiveDomainReason, getIsPublishEnabled, getIsUnpublishEnabled, getPagesTypeHasSavedViews, getHasPermissionsToPublish
// @ts-expect-error Untyped module
} from '../redux/selectors/pagePublishSelectors';
import { getPageErrorLabels, getPageWarningLabels, getPageInfoLabels
// @ts-expect-error untyped module
} from '../redux/selectors/pageWarningsAndSuggestionsSelectors';
import { getCanSchedule, getCanUseUniversalThemeEditor } from '../redux/selectors/authSelectors';
import MABPublishConfirmModal from '../components/MABPublishConfirmModal';
import PagePublishConfirmModalBody from '../components/PagePublishConfirmModalBody';
import UseCaseTourCompleteModal from '../components/UseCaseTourCompleteModal';
import { UCAONextActionModal } from '../components/UCAONextActionModal';

// @ts-expect-error Untyped module
import { updateFocusedItem } from 'page-editor-ui/redux/actions/pageFocusActions';
import usePublishLifecycleHandlers from '../hooks/usePublishLifecycleHandlers';
import { getAbMasterName, getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { getIsMABExperiment, getIsMabVariant, getMABExperimentIsStarted, getMABExperimentPrimayVariantName
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
// @ts-expect-error Untyped module
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getContentModelPublicAccessRules, getContentModelPassword } from '../redux/selectors/pageContentModelSelectors';
// @ts-expect-error Untyped module
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
// @ts-expect-error Untyped module
import { getHasExceededMlangPagesLimit } from '../redux/selectors/pageLimitSelectors';
// @ts-expect-error Untyped module
import { getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey } from '../redux/selectors/downgradeSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { useCMPPublishActionHandlers } from 'ContentEditorUI/components/publishing/hooks/usePublishActionHandlers';
import { getPageSettingsFullUrl } from '../redux/selectors/pageSettingsSelectors';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { getContentModelPageExpiryRedirectUrl } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getMembershipSsoEnabledForDomain } from '../redux/selectors/membershipsSelectors';
import { EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD } from 'ui-memberships-settings-lib/components/alerts/RegistrationEmailSendingAcknowledgement';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey } from 'ui-memberships-settings-lib/utils/tooltips';
// @ts-expect-error Untyped module
import { search } from 'ContentEditorUI/api/PagesApi';
import useContentCrmObject from 'ContentEditorUI/components/publishing/hooks/useContentCrmObject';
import { publishSettingsBuffer } from 'theme-previewer-lib/actions/ThemeSettingsActions';
import { usePersonalizationPublishValidation } from '../hooks/usePersonalizationPublishValidation';
import { getHasBufferedChanges, getHasBufferdChangesRequestStatus } from 'theme-previewer-lib/selectors/themeSettingsMetaSelectors';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
// @ts-expect-error Untyped module
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { fetchHasBufferedSettingsChanges as fetchHasBufferedThemeSettingsChanges } from 'theme-previewer-lib/actions/ThemeSettingsActions';
import { getThemeSettingsId } from 'theme-previewer-lib/selectors/themeSettingsSelectors';
import { UNINITIALIZED } from 'theme-previewer-lib/constants/RequestStatusTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const useConfirmPublishActionProps = () => {
  var _pagePublicAccessRule;
  const [unregisteredContactsCount, setUnregisteredContactsCount] = useState(0);
  const [isEmailSendingAcknowledgementChecked, setIsEmailSendingAcknowledgementChecked] = useState(false);
  const pagePublicAccessRules = useSelector(getContentModelPublicAccessRules);
  const pagePassword = useSelector(getContentModelPassword);
  const ssoEnabledForPageDomain = useSelector(getMembershipSsoEnabledForDomain);
  const pageIsPublic = (pagePublicAccessRules.length === 0 || pagePublicAccessRules[0].type === PublicAccessRuleTypes.PUBLIC) && !pagePassword;
  const pageHasAccessGroupsMembership = ((_pagePublicAccessRule = pagePublicAccessRules[0]) === null || _pagePublicAccessRule === void 0 ? void 0 : _pagePublicAccessRule.type) === PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP && !ssoEnabledForPageDomain;
  const disabledForMissingEmailSendingAcknowledgement = pageHasAccessGroupsMembership && unregisteredContactsCount >= EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD && !isEmailSendingAcknowledgementChecked;
  const handleUnregisteredContactsCountFetchSuccess = count => {
    setUnregisteredContactsCount(count);
  };
  const handleEmailSendingAcknowledgementChange = checked => {
    setIsEmailSendingAcknowledgementChecked(checked);
  };
  return useMemo(() => ({
    publishConfirmDisabled: disabledForMissingEmailSendingAcknowledgement,
    publishConfirmDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey()
    }),
    publishConfirmModalBodyContent: /*#__PURE__*/_jsx(PagePublishConfirmModalBody, {
      isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
      onEmailSendingAcknowledgementChange: handleEmailSendingAcknowledgementChange,
      onUnregisteredContactsCountFetchSuccess: handleUnregisteredContactsCountFetchSuccess
    }),
    shouldConfirmPublishAction: !pageIsPublic
  }), [disabledForMissingEmailSendingAcknowledgement, isEmailSendingAcknowledgementChecked, pageIsPublic]);
};
const PagePublishButtonContainer = () => {
  const dispatch = useDispatch();

  // Conditional fetch for validating only personalized pages:
  const {
    isPublishDisabledDueToPersonalization,
    isUnpublishDisabledDueToPersonalization,
    variantPublishDisabledMessage
  } = usePersonalizationPublishValidation();
  const cannotPublishOnDomainReason = useSelector(getCannotPublishOnActiveDomainReason);
  const errors = useSelector(getPageErrorLabels);
  const baseWarnings = useSelector(getPageWarningLabels);
  const infos = useSelector(getPageInfoLabels);
  const canSchedule = useSelector(getCanSchedule);
  const publishEnabled = useSelector(getIsPublishEnabled);
  const unpublishEnabled = useSelector(getIsUnpublishEnabled);
  const isAbVariant = useSelector(getIsABVariant);
  const isMabVariant = useSelector(getIsMabVariant);
  const abPrimaryName = useSelector(getAbMasterName);
  const mabPrimaryName = useSelector(getMABExperimentPrimayVariantName);
  const isMABExperiment = useSelector(getIsMABExperiment);
  const mabExperimentIsStarted = useSelector(getMABExperimentIsStarted);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const controlCenterUrl = useSelector(getDashboardUrl);
  const hasExceededMlangSitePagesLimit = useSelector(getHasExceededMlangPagesLimit);
  const canUseUniversalThemeEditor = useSelector(getCanUseUniversalThemeEditor);
  const themeSettingsId = useSelector(getThemeSettingsId);
  const hasBufferedChanges = useSelector(getHasBufferedChanges);
  const hasBufferedChangesRequestStatus = useSelector(getHasBufferdChangesRequestStatus);
  useEffect(() => {
    //on mount fetch hasBufferedThemeSettingsChanges after theme settings is fetched
    //to account for both revert and theme settings updates
    if (canUseUniversalThemeEditor && themeSettingsId && hasBufferedChangesRequestStatus === UNINITIALIZED) {
      dispatch(fetchHasBufferedThemeSettingsChanges());
    }
  }, [dispatch, canUseUniversalThemeEditor, themeSettingsId, hasBufferedChangesRequestStatus]);
  const warnings = useMemo(() => {
    const warningsList = [...baseWarnings];
    if (isUnpublishDisabledDueToPersonalization) {
      warningsList.push({
        message: 'personalizationPublishValidation.cannotUnpublishDefault',
        useHtml: true
      });
    }
    return warningsList;
  }, [baseWarnings, isUnpublishDisabledDueToPersonalization]);
  const tooltipOverride = useMemo(() => {
    if (hasExceededMlangSitePagesLimit) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "mLang.sitePageLimitExceededError",
        options: {
          controlCenterUrl
        }
      });
    } else if (isReadOnlyMode) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'app.readOnly.publishButton.pages'
      });
    } else if (isPublishDisabledDueToPersonalization) {
      return variantPublishDisabledMessage;
    }
    return;
  }, [controlCenterUrl, hasExceededMlangSitePagesLimit, isReadOnlyMode, isPublishDisabledDueToPersonalization, variantPublishDisabledMessage]);
  const [mabConfirmModalOpen, setMabConfirmModalOpen] = useState(false);
  const [showUseCaseTourCompleteModal, setShowUseCaseTourCompleteModal] = useState(false);
  const [showNextActionModal, setShowNextActionModal] = useState(false);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const hasExceededContentTypeLimit = useSelector(getHasContentTypeLimitReducerAndExceededLimit);
  const hasStagingDomain = useSelector(getHasStagingDomain);
  const upgradeModalKey = useSelector(getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey);
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const contentTypeHasSavedViews = useSelector(getPagesTypeHasSavedViews);
  const publishLifecycleHandlers = usePublishLifecycleHandlers(setShowUseCaseTourCompleteModal, setShowNextActionModal);
  const {
    publish,
    unpublish,
    schedulePublishUnpublish
  } = useCMPPublishActionHandlers(publishLifecycleHandlers);
  const hasPermissionsToPublish = useSelector(getHasPermissionsToPublish);
  const {
    contentCrmObjectPublishType
  } = useContentCrmObject();
  const confirmPublishActionProps = useConfirmPublishActionProps();
  const pageExpiryRedirectUrl = useSelector(getContentModelPageExpiryRedirectUrl);
  const {
    contentCrmObject
  } = useContentCrmObject();
  const unpublishExpiryUrl = contentCrmObject ? getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.UNPUBLISH_EXPIRY_URL) : pageExpiryRedirectUrl;
  const loadRedirectUrlOptions = (input, callback) => {
    search(input).then(resp => {
      callback(null, {
        options: resp.objects.map(page => {
          return {
            text: page.name ? `${page.name} (${page.url})` : page.url,
            value: page.url
          };
        }).filter(page => {
          return page.value !== unpublishExpiryUrl;
        })
      });
    }).catch(() => {
      // no op
    });
  };
  const handlePublish = publishType => {
    if (canUseUniversalThemeEditor && hasBufferedChanges) {
      dispatch(publishSettingsBuffer());
    }
    publish(publishType);
  };
  const unpublishFooter = canUseUniversalThemeEditor ? /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Text, {
      as: "small",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: InfoIcon,
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.universalThemeFooter"
      }), /*#__PURE__*/_jsx(Link, {
        onClick: () => dispatch(routeToPage('revisions')),
        paddingInlineStart: "100",
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unpublishModal.universalThemeFooterLink"
        })
      })]
    })
  }) : null;
  const publishFooter = canUseUniversalThemeEditor && hasBufferedChanges ? /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Text, {
      as: "small",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: WarningIcon,
        paddingInlineEnd: "100",
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publishConfirmModal.body.pageWithUniversalTheme.footer"
      })]
    })
  }) : null;
  const getSchedulePublishDescription = (scheduledTime, portalTimezone) => {
    if (canUseUniversalThemeEditor) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.body.pageWithUniversalTheme.schedule",
        options: {
          scheduledTime,
          portalTimezone
        }
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditorPublishButton, {
      cannotPublishOnDomainReason: cannotPublishOnDomainReason,
      errors: errors,
      warnings: warnings,
      infos: infos,
      canSchedule: canSchedule && !isBlogListingPage && !hasExceededContentTypeLimit && !hasStagingDomain && !isPublishDisabledDueToPersonalization,
      publishEnabled: publishEnabled && !isPublishDisabledDueToPersonalization,
      unpublishEnabled: unpublishEnabled && !isUnpublishDisabledDueToPersonalization,
      testVariationTooltipPropsForApproval: {
        isTestVariation: isAbVariant || isMabVariant,
        testVariationDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "approvals.testVariationRequestApprovalDisabledTooltip",
          options: {
            name: abPrimaryName || mabPrimaryName
          }
        })
      },
      buttonTextKey: hasStagingDomain ? `header.publishButton.staging.${contentCrmObjectPublishType}.label` : undefined,
      updateFocusedItemAction: updateFocusedItem,
      tooltipOverride: tooltipOverride,
      lockedPublishButtonProps: {
        isLocked: hasExceededContentTypeLimit,
        onClickLocked: openUpgradeModal
      },
      schedulingOptionsModalProps: {
        dashboardUrl: controlCenterUrl,
        allowBackdating: false,
        canScheduleUnpublish: !isUnpublishDisabledDueToPersonalization,
        contentTypeHasSavedViews,
        unpublishRedirectOptions: {
          allowRedirectOnUnpublish: true,
          loadRedirectUrlOptions
        }
      },
      confirmPublishActionProps: confirmPublishActionProps,
      customPublishActionProps: {
        shouldUseCustomPublishHandler: isMABExperiment && !mabExperimentIsStarted,
        customPublishHandler: () => setMabConfirmModalOpen(true)
      },
      publish: handlePublish,
      unpublish: unpublish,
      schedulePublishUnpublish: schedulePublishUnpublish,
      isNotAuthorizedToPublish: !hasPermissionsToPublish && !hasExceededContentTypeLimit,
      buttonSize: "medium",
      unpublishFooter: unpublishFooter,
      publishFooter: publishFooter,
      getSchedulePublishDescription: getSchedulePublishDescription,
      confirmScheduleButtonTextKey: canUseUniversalThemeEditor ? 'publishConfirmModal.body.pageWithUniversalTheme.confirmSchedule' : undefined
    }), mabConfirmModalOpen && /*#__PURE__*/_jsx(MABPublishConfirmModal, {
      dismissCallback: () => setMabConfirmModalOpen(false)
    }), showUseCaseTourCompleteModal && /*#__PURE__*/_jsx(UseCaseTourCompleteModal, {
      onClose: () => {
        setShowUseCaseTourCompleteModal(false);
      },
      websiteLink: pageSettingsFullUrl
    }), showNextActionModal && /*#__PURE__*/_jsx(UCAONextActionModal, {
      onClose: () => setShowNextActionModal(false)
    })]
  });
};
export default PagePublishButtonContainer;